<template>
  <div class="container">
    <cmp-header></cmp-header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
// import cmpHeader from '@cmp/cmp-header'
// import Footer from '@cmp/footer.vue'
export default {
  components: {
    // cmpHeader,
    // Footer
  }
}
</script>
